(function () {
    'use strict';
    angular.module('doclr.disciplines', []);
})();
